import React from 'react';
import Icon from '@pushpay/icon';
import { clsx, createUseStyles } from '@pushpay/styles';
import { AppStudioTheme, isGivingOldTheme } from '@pushpay/theming';
const useStyles = createUseStyles(theme => ({
  root: {
    color: isGivingOldTheme(theme) ? '#0BA2AD' : AppStudioTheme.colors['product-color']
  }
}));

const MobileAppStudioIcon = ({
  classes: classesProp,
  className: classNameProp,
  ...rest
}) => {
  const classes = useStyles(classesProp);
  const className = clsx(classNameProp, classes.root);
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24",
    className: className
  }, rest), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 24,
    height: 24,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.34 12.024h1.89V6.582c0-.98-.802-1.782-1.782-1.782H6.582c-.98 0-1.782.802-1.782 1.782v6.866c0 .98.802 1.782 1.782 1.782h5.442v-1.89a1.32 1.32 0 011.316-1.316z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.416 12.024H15.23v1.424c0 .98-.802 1.782-1.782 1.782h-1.424v3.186a1.32 1.32 0 001.316 1.316h5.076a1.32 1.32 0 001.316-1.316V13.34a1.317 1.317 0 00-1.316-1.316z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.23 13.45v-1.424h-1.89a1.32 1.32 0 00-1.316 1.316v1.89h1.424a1.79 1.79 0 001.782-1.782zM7.742 16.186H5.406a.607.607 0 00-.606.606v2.336c0 .334.272.606.606.606h2.336a.607.607 0 00.606-.606v-2.336a.608.608 0 00-.606-.606z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.086 4.802H16.59a.65.65 0 00-.648.648v2.496a.65.65 0 00.648.648h2.496a.65.65 0 00.648-.648V5.448a.649.649 0 00-.648-.646z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.5
  }));
};

export default MobileAppStudioIcon;